//
// Copyright (c) 2021 Astute Global, Inc.
//

import { Command } from "ckeditor5";

const DEFAULT_INSERT_TYPE = "text";
const INSERT_TYPES = ["text", "image", "link", "html"];

class ResponseAttributeCommand extends Command {
  constructor(editor) {
    super(editor);
    this.set({
      insertType: DEFAULT_INSERT_TYPE,
      attributeName: null,
    });
  }

  execute(options) {
    let executeOptions;
    if (!options) {
      if (!this.value) {
        return;
      }

      executeOptions = {
        insertType: this.insertType,
        attributeId: this.value,
        attributeName: this.attributeName,
      };
    } else {
      executeOptions = Object.assign({}, options);
    }
    if (!executeOptions.attributeName) {
      executeOptions.attributeName = this.editor.config.get("responseAttribute.emptyAttributeName");
    }
    const model = this.editor.model;
    model.change((writer) => {
      const attribute = writer.createElement("responseAttribute", executeOptions);
      model.insertContent(attribute);
      writer.setSelection(attribute, "on");
    });
  }

  refresh() {
    const model = this.editor.model;
    const selection = model.document.selection;
    const element = selection.getSelectedElement();
    if (element && element.is("element", "responseAttribute")) {
      this.isEnabled = true;
      this.insertType = element.getAttribute("insertType");
      this.value = element.getAttribute("attributeId");
      this.attributeName = element.getAttribute("attributeName");
    } else {
      const allowedIn = model.schema.findAllowedParent(
        selection.getFirstPosition(),
        "responseAttribute",
      );

      this.isEnabled = !!allowedIn;
      this.insertType = DEFAULT_INSERT_TYPE;
      this.value = "";
      this.attributeName = "";
    }
  }
}

export { DEFAULT_INSERT_TYPE, INSERT_TYPES, ResponseAttributeCommand };
